import React, { useContext, useEffect, useState } from 'react';
import styles from './Modal.module.css';
import { StoreContext } from '../../utils/store';

const Modal = () => {
  const context = useContext(StoreContext);
  const [modalStatus, setModalStatus] = context.modalStatus;
  // const [, setOverlayActive] = context.overlayActive;
  // const [modalActive, setModalActive] = context.modalActive;
  // const [modalHeaderText, setModalHeaderText] = context.modalHeaderText;
  // const [modalBodyText, setModalBodyText] = context.modalBodyText;
  const errorColors = { background: '#f8d7da', border: '#f5c2c7', text: '#842029' };
  const warningColors = { background: '#fff3cd', border: '#ffecb5', text: '#664d03' };
  const successColors = { background: '#d1e7dd', border: '#badbcc', text: '#0f5132' };
  const notificationColors = { background: '#cfe2ff', border: '#b6d4fe', text: '#084298' };
  const [colors, setColors] = useState({
    background: 'white', border: 'black', text: 'black'
  });
  const closeModal = () => {
    setModalStatus(status => ({
      ...status,
      modalActive: false,
      overlayActive: false,
      modalHeaderText: '',
      modalBodyText: '',
      modalColors: '',
    }));
  };
  useEffect(() => {
    switch (modalStatus.modalColors) {
      case 'error':
        setColors(errorColors);
        break;
      case 'warning':
        setColors(warningColors);
        break;
      case 'success':
        setColors(successColors);
        break;
      case 'notification':
        setColors(notificationColors);
        break;
      default:
        break;
    }
  }, [modalStatus]);
  useEffect(() => {
    const escape = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    }
    window.addEventListener('keyup', (e) => escape(e));
    return () => {
      window.removeEventListener('keyup', (e) => escape(e));
    }
  }, []);
  return (
    <div className={modalStatus.modalActive ? styles.modalActive : styles.modalHidden} >
      <div
        className={styles.header}
        style={{
          backgroundColor: colors.background,
          borderColor: colors.border,
          color: colors.text,
        }}>
        <div
          data-test-target='modal-header'
          className={styles.title}
        >
          {modalStatus.modalHeaderText}
        </div>
        <button
          aria-label='close-modal'
          className={styles.closeButton}
          onClick={closeModal}
        >&times;</button>
      </div>
      <div className={styles.body}>
        <div className={styles.text}>
          {modalStatus.modalBodyText}
        </div>
      </div>
    </div>
  );
};

export default Modal;
